// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorAPI_errorContainer__L6j_q","errorContainerLandscape":"ErrorAPI_errorContainerLandscape__xwa2q"};